import React from "react";
import logo from "../assets/dialhoop.png";
import logo1 from "../assets/dialhoop_logo.png";
import wordmark from "../assets/dialhoop_name.png";
import { ACCENT, ACCENT2, BORDER, MUTED, TEXT } from "../utils/constants";

/* ── Logo — bigger, with a soft glow ring so it pops on dark bg ── */
export const Logo = ({ size = 48 }) => (
  <div style={{
    width: size, height: size, borderRadius: "50%", flexShrink: 0,
    boxShadow: `0 0 0 2px rgba(255,255,255,0.12), 0 0 16px rgba(124,111,255,0.35)`,
    overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center",
  }}>
    <img src={logo} alt="DialHoop" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
  </div>
);

export const Brand = () => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <img
        src={logo1}
        alt="DialHoop logo"
        style={{
          width: 36,
          height: 36,
          borderRadius: "50%",
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
        }}
      />
      <img
        src={wordmark}
        alt="DialHoop"
        style={{ height: 18, objectFit: "contain" }}
      />
    </div>
  );
};

/* ── Buttons ── */
export const BtnPrimary = ({ children, style, ...p }) => (
  <button style={{
    background: `linear-gradient(135deg, ${ACCENT}, ${ACCENT2})`,
    color: "#fff", border: "none", padding: "14px 28px",
    borderRadius: 100, fontSize: 15, fontWeight: 600,
    cursor: "pointer", fontFamily: "DM Sans, sans-serif",
    boxShadow: "0 0 28px rgba(124,111,255,0.25)",
    lineHeight: 1.2, transition: "opacity .15s, transform .12s",
    ...style,
  }} {...p}>{children}</button>
);

export const BtnGhost = ({ children, style, ...p }) => (
  <button style={{
    background: "transparent", color: TEXT,
    border: `1px solid ${BORDER}`,
    padding: "13px 24px", borderRadius: 100,
    fontSize: 14, fontWeight: 400,
    cursor: "pointer", fontFamily: "DM Sans, sans-serif",
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    lineHeight: 1.2,
    ...style,
  }} {...p}>{children}</button>
);

/* ── Form section label ── */
export const FSectionLabel = ({ children }) => (
  <div style={{
    fontFamily: "Syne, sans-serif", fontSize: 11, fontWeight: 700,
    color: "#a89fff", letterSpacing: "0.9px", textTransform: "uppercase",
    paddingTop: 16, marginTop: 4,
    borderTop: `1px solid ${BORDER}`,
  }}>{children}</div>
);

/* ── Confirm Dialog ── */
export const ConfirmDialog = ({ title, body, confirmLabel = "Delete", onConfirm, onCancel }) => (
  <div style={{
    position: "fixed", inset: 0, zIndex: 8000,
    background: "rgba(0,0,0,0.72)", backdropFilter: "blur(6px)",
    display: "flex", alignItems: "center", justifyContent: "center", padding: 20,
  }}>
    <div style={{
      background: "#0f1629", border: "1px solid rgba(255,255,255,0.1)",
      borderRadius: 20, padding: 28, maxWidth: 380, width: "100%",
    }}>
      <div style={{ fontFamily: "Syne, sans-serif", fontSize: 17, fontWeight: 700, color: "#fff", marginBottom: 10 }}>{title}</div>
      <div style={{ fontSize: 14, color: "rgba(240,238,248,0.55)", lineHeight: 1.65, marginBottom: 22 }}>{body}</div>
      <div style={{ display: "flex", gap: 10 }}>
        <button onClick={onCancel} style={{ flex: 1, padding: "11px", borderRadius: 10, background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)", color: "#fff", cursor: "pointer", fontFamily: "DM Sans, sans-serif", fontSize: 14 }}>Cancel</button>
        <button onClick={onConfirm} style={{ flex: 1, padding: "11px", borderRadius: 10, background: "linear-gradient(135deg,#e74c3c,#c0392b)", border: "none", color: "#fff", cursor: "pointer", fontFamily: "DM Sans, sans-serif", fontSize: 14, fontWeight: 600 }}>{confirmLabel}</button>
      </div>
    </div>
  </div>
);

/* ── Nav ── */
export const Nav = ({ right, fixed = true }) => (
  <nav style={{
    position: fixed ? "fixed" : "relative",
    top: 0, left: 0, right: 0, zIndex: 100,
    display: "flex", alignItems: "center", justifyContent: "space-between",
    padding: "12px 24px",
    background: "rgba(8,11,24,0.85)",
    backdropFilter: "blur(24px)",
    borderBottom: `1px solid ${BORDER}`,
    minHeight: 64,
  }}>
    <div style={{ display: "flex", alignItems: "center", gap: 11 }}>
      <Brand size={44} /></div>
    <div style={{ display: "flex", alignItems: "center" }}>{right}</div>
  </nav>
);

/* ── BG decorations ── */
export const BgDecorations = () => (
  <>
    <div style={{ position: "fixed", top: "-20%", left: "30%", width: 700, height: 700, borderRadius: "50%", background: "radial-gradient(circle, rgba(124,111,255,0.12) 0%, transparent 70%)", pointerEvents: "none", zIndex: 0 }} />
    <div style={{ position: "fixed", top: "40%", right: "-10%", width: 500, height: 500, borderRadius: "50%", background: "radial-gradient(circle, rgba(255,107,157,0.08) 0%, transparent 70%)", pointerEvents: "none", zIndex: 0 }} />
    <div style={{ position: "fixed", inset: 0, zIndex: 0, pointerEvents: "none", backgroundImage: "linear-gradient(rgba(255,255,255,0.022) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.022) 1px, transparent 1px)", backgroundSize: "60px 60px", WebkitMaskImage: "radial-gradient(ellipse 80% 80% at 50% 20%, black 20%, transparent 80%)", maskImage: "radial-gradient(ellipse 80% 80% at 50% 20%, black 20%, transparent 80%)" }} />
  </>
);

/* ── MedSelect — styled dropdown for medical fields ── */
export const MedSelect = ({ options, value, onChange, err, style, disabled }) => (
  <div style={{ position: "relative", ...style }}>
    <select
      value={value}
      onChange={onChange}
      disabled={disabled}
      style={{
        width: "100%",
        padding: "11px 36px 11px 13px",
        background: "rgba(255,255,255,0.07)",
        border: `1px solid ${err ? "rgba(231,76,60,0.6)" : "rgba(255,255,255,0.12)"}`,
        borderRadius: 9,
        color: value ? "#F0EEF8" : "rgba(240,238,248,0.38)",
        fontSize: 14,
        fontFamily: "DM Sans, sans-serif",
        outline: "none",
        appearance: "none",
        WebkitAppearance: "none",
        cursor: "pointer",
        boxSizing: "border-box",
      }}
    >
      {options.map(o => (
        <option key={o.value} value={o.value} style={{ background: "#0d1225", color: o.value ? "#F0EEF8" : "#888" }}>
          {o.label}
        </option>
      ))}
    </select>
    {/* Custom chevron */}
    <div style={{
      position: "absolute", right: 12, top: "50%",
      transform: "translateY(-50%)",
      pointerEvents: "none", color: "rgba(240,238,248,0.45)", fontSize: 12,
    }}>▼</div>
  </div>
);

/* ── Global CSS ── */
export const GlobalStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');
    *, *::before, *::after { box-sizing: border-box; }
    html { scroll-behavior: smooth; }
    body { margin: 0; background: #080B18; color: #F0EEF8; font-family: 'DM Sans', sans-serif; -webkit-font-smoothing: antialiased; }
    a { text-decoration: none; }
    input, select, textarea { box-sizing: border-box; }
    input::placeholder { color: rgba(240,238,248,0.3); }
    input:focus { border-color: rgba(124,111,255,0.55) !important; outline: none; }
    input[type=date] { color-scheme: dark; }
    input[type=file] { cursor: pointer; }
    button { touch-action: manipulation; }
    button:disabled { opacity: 0.6; cursor: not-allowed; }
    @keyframes floatY  { 0%,100%{transform:translateY(0)}  50%{transform:translateY(-10px)} }
    @keyframes pulse   { 0%,100%{opacity:1} 50%{opacity:0.4} }
    @keyframes fadeUp  { from{opacity:0;transform:translateY(18px)} to{opacity:1;transform:translateY(0)} }
    @keyframes slideUp { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
    ::-webkit-scrollbar       { width:4px; height:4px; }
    ::-webkit-scrollbar-thumb { background:rgba(255,255,255,0.12); border-radius:4px; }
    /* ── Mobile ── */
    @media (max-width: 640px) {
      .nav-links   { display: none !important; }
      .feat-grid   { grid-template-columns: 1fr !important; }
      .feat-span2  { grid-column: span 1 !important; }
      .steps-grid  { grid-template-columns: 1fr 1fr !important; }
      .step        { border-right: none !important; border-bottom: 1px solid rgba(255,255,255,0.08) !important; }
      .stats-row   { flex-direction: column !important; align-items: stretch !important; }
      .stat-item   { border-right: none !important; border-bottom: 1px solid rgba(255,255,255,0.08) !important; padding: 14px 20px !important; text-align: center; }
      .preview-flex { flex-direction: column !important; gap: 24px !important; }
      .hero-actions { flex-direction: column !important; align-items: stretch !important; }
      .hero-actions button, .hero-actions a { width: 100% !important; box-sizing: border-box; justify-content: center; }
      .qr-float    { display: none !important; }
      .cta-section { margin: 20px 12px 60px !important; padding: 36px 20px !important; }
      .footer-row  { flex-direction: column !important; text-align: center; gap: 10px !important; padding: 20px 16px !important; }
    }
    @media (max-width: 480px) {
      .steps-grid  { grid-template-columns: 1fr !important; }
    }
  `}</style>
);
